import React, { Fragment } from 'react';

import { Button, Form, Input, Tooltip } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import FaqLink from './FaqLink';
import FacebookForm from '../FacebookForm';
import Platforms, { enTypePlatform } from '../Platforms';

interface IProps {
  conversionLabel: string;
  tokenApi: string;
  loading: boolean;
  platformType: enTypePlatform;
  pixel: string;
  pixelId: string;
  handleConversionLabel: (conversionLabel: string) => void;
  handlePixel: (pixel: string) => void;
  handleDelete: (idPixel: any, type: string) => Promise<void>;
  handleTokenApi: (tokenApi: string) => void;
  back: () => void;
}

function Basic({
  platformType,
  loading,
  conversionLabel,
  tokenApi,
  pixel,
  pixelId,
  handleConversionLabel,
  handleTokenApi,
  handleDelete,
  handlePixel,
  back
}: IProps) {
  const platform = (Platforms || []).find(x => x.type === platformType);

  const imgUrl = platform?.image || '';
  const label = platform?.label || '';
  return (
    <Fragment>
      {platformType != null && (
        <div>
          <div className='flex items-center gap-2'>
            <Tooltip title='Voltar' placement='top'>
              <Button type='text' shape='circle' onClick={() => back()} icon={<Icon.ArrowLeft size={16} />} />
            </Tooltip>
            <img src={imgUrl} alt='platform' className='max-h-8 max-w-full' />
          </div>
          <div className='mt-8' />
          <div>
            <div className='flex items-end gap-2'>
              <Form.Item label={label} className='mb-0'>
                <Input size='small' value={pixel} onChange={(e: any) => handlePixel(e.target.value)} />
              </Form.Item>
              {pixelId !== '' && (
                <Tooltip title='Deletar Pixel' placement='top'>
                  <Button
                    type='text'
                    onClick={() => handleDelete(pixelId, platformType)}
                    icon={<Icon.Trash2 size={16} />}
                  />
                </Tooltip>
              )}
            </div>
            {platformType !== enTypePlatform.FACEBOOK && <FaqLink link={platform.faqUrl} />}

            <div className='mt-8' />

            {platformType === enTypePlatform.FACEBOOK && (
              <FacebookForm loading={loading} tokenApi={tokenApi} handleTokenApi={handleTokenApi} />
            )}
            {platformType === enTypePlatform.ADWORDS && (
              <Fragment>
                <div className='mt-6' />
                <div className='flex items-end'>
                  <Form.Item label='Label de conversão'>
                    <Input
                      size='small'
                      value={conversionLabel}
                      onChange={(e: any) => handleConversionLabel(e.target.value)}
                    />
                  </Form.Item>
                </div>
              </Fragment>
            )}
          </div>
          <div className='mt-2' />
        </div>
      )}
    </Fragment>
  );
}

export default Basic;
